import React from 'react';
import WorkQueuePhaseIcon from './WorkQueuePhaseIcon.jsx';
import styles from './WorkQueue.module.scss';

function WorkQueueSubmissionCell({ data, condensedMode }) {
  if (!data) return null;

  return (
    <div className={`${styles.submissionCell} ${condensedMode ? styles.condensed : ''}`}>
      <WorkQueuePhaseIcon phaseKind={data.phase_kind} />
      <div className={styles.nameCell}>
        <div className={styles.name}>
          <a href={data.phase_path}>{data.project_identifier}</a>
          {data.submission_title && <span className={styles.muted}> – {data.submission_title}</span>}
        </div>
        <div className={styles.description}>{data.workflow_name} · {data.phase_name}</div>
      </div>
    </div>
  );
}

export default WorkQueueSubmissionCell;
